import { ProfileEntity } from "../profile/profile-entity";

export declare class Evaluator {
  public profile: ProfileEntity;
}